<template>
  <material-card v-bind="$attrs" class="v-card--material-stats" v-on="$listeners">
    <v-card
      slot="offset"
      :class="`elevation-${elevation}`"
      :color="color"
      class="pa-4 display-1"
      dark
    >
      <div style="min-width:60px;text-align:center">{{ value1 }}</div>
    </v-card>
    <div class="text-right">
      <p class="category grey--text font-weight-light" v-text="title" />
      <h3 class="title display-1 font-weight-light">
        {{ value2 }}
        <small>{{ smallValue }}</small>
      </h3>
    </div>

    <template slot="actions">
      <v-btn
        v-if="subText!=''"
        @click="cardAction"
        :color="subTextColor"
        :loading="subIconLoading"
        text
        small
      >
        <v-icon left small>{{subIcon}}</v-icon>
        {{subText}}
      </v-btn>
      <span v-if="textOnly" class="caption grey--text mt-2 ml-1">{{textOnly}}</span>
    </template>
  </material-card>
</template>

<script>
import materialCard from "@/components/material/Card";
const logs = require("@/classes/logs/logs.js").Logs;
export default {
  components: {
    materialCard
  },
  inheritAttrs: false,
  props: {
    ...materialCard.props,
    icon: {
      type: String,
      required: true
    },
    subIcon: {
      type: String,
      default: undefined
    },
    subIconColor: {
      type: String,
      default: undefined
    },
    subIconLoading: {
      default: false
    },
    subTextColor: {
      type: String,
      default: undefined
    },
    textOnly: {
      type: String,
      default: undefined
    },

    subText: {
      default: ""
    },
    title: {
      type: String,
      default: undefined
    },
    value1: {
      default: undefined
    },
    value2: {
      default: undefined
    },
    smallValue: {
      type: String,
      default: undefined
    }
  },
  methods: {
    cardAction() {
      logs.print("init");
      this.$emit("cardAction");
    }
  }
};
</script>

<style lang="scss">
.v-card--material-stats {
  display: flex;
  flex-wrap: wrap;
  position: relative;

  .v-offset {
    display: inline-block;
    flex: 0 1;
    margin-top: 0;
    margin-left: 0;
    margin-right: auto;
    margin-bottom: 0 !important;
    max-width: auto;
    padding: 0 16px 0;
  }

  .v-card {
    border-radius: 4px;
    flex: 0 1 auto;
  }

  .v-card__text {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
  }

  .v-card__actions {
    flex: 1 0 100%;
  }
}
</style>
